export default __webpack_public_path__ + "static/mainfeatureai1-7c219a9b19e42e3806a2aa96d0efcf0d.svg";